import { render, staticRenderFns } from "./BlackbearTextInput.vue?vue&type=template&id=e5bbe348&"
import script from "./BlackbearTextInput.vue?vue&type=script&lang=ts&"
export * from "./BlackbearTextInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports